import React from "react";
import { MapPin, Truck } from "lucide-react";
import DeliveryOptionCard from "./DeliveryOptionCard";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const DeliveryOptions = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const optionsData = labels.menuPages?.buyCar?.deliverySection?.options || [];

  const icons = [
    <MapPin className="w-4 h-4 md:w-6 md:h-6" />,
    <Truck className="w-4 h-4 md:w-6 md:h-6" />,
  ];
  const colors = ["from-blue-500 to-cyan-500", "from-green-500 to-emerald-500"];

  const deliveryOptions = optionsData.map((option: any, index: number) => ({
    icon: icons[index] || icons[0],
    title: option.title || "",
    description: option.description || "",
    features: option.features || [],
    color: colors[index] || colors[0],
  }));

  return (
    <div className="flex justify-center items-center mb-12 md:mb-16">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-4xl w-full">
        {deliveryOptions.map((option, index) => (
          <DeliveryOptionCard key={index} option={option} index={index} />
        ))}
      </div>
    </div>
  );
};

export default DeliveryOptions;
